import React, { ReactNode } from 'react';
import classNames from 'classnames';
import usePastTime from 'hooks/usePastTime';

import './TimelineNode.styles.scss';

type TimelineNodeProps = {
  className?: string;
  date: Date;
  text: ReactNode;
};

const TimelineNode: React.FC<TimelineNodeProps> = (props) => {
  const { className, children, date, text } = props;

  const classes = classNames('timeline-node', className);

  const pastTime = usePastTime();

  return (
    <div className={classes}>
      <div className="date">{pastTime(date)}</div>
      <div className="activity">
        {text}
        {children}
      </div>
    </div>
  );
};

export default TimelineNode;
